import classNames from 'classnames'
import { DateTime } from 'luxon'
import { Link } from 'react-router'
import { Routes } from '../routes'
import { AnalysisResponse } from '../utils/api-client/api-schemas.ts'
import { getToolName } from '../utils/repository-utils.tsx'
import CloseIcon from './icons/close-icon.svg?react'
import DotIcon from './icons/dot-icon.svg?react'
import * as styles from './latest-analysis-link.css.ts'

export function LatestAnalysisLink({ latestAnalysis }: { latestAnalysis: AnalysisResponse }) {
  const scan = latestAnalysis._embedded?.scan
  if (!scan) {
    return null
  }

  const toolName = getToolName(scan.detector) ?? 'Analysis'
  const isInProgress = ['queued', 'in-progress'].includes(latestAnalysis.current_state.state)
  const isFailed = latestAnalysis.current_state.state === 'failed'
  const isCompleted = 'completed' === latestAnalysis.current_state.state
  const showNeutralStyle = isInProgress || isFailed

  return (
    <Link
      to={Routes.ScanDetailsPage.createPath({ scanId: scan.id })}
      className={classNames(styles.analysisLink, {
        [styles.inProgress]: showNeutralStyle,
      })}
    >
      {toolName}
      {isCompleted && (
        <span className={styles.completedLabel}>
          {DateTime.fromISO(latestAnalysis.current_state.timestamp).toRelative()}
        </span>
      )}
      {isInProgress && <DotIcon className={styles.progressIcon} />}
      {isFailed && <CloseIcon className={styles.closeIcon} />}
    </Link>
  )
}
